import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Homepage from "./pages/Homepage";
import JreApproval from "./pages/JreApproval";
import AdminLiveMap from "./pages/AdminLiveMap";
import { OperatorProvider, useOperator } from "./contexts/OperaotrContext.jsx";
import { useLocation } from "react-router-dom";
import OperaotrRegistration from "./pages/OperaotrRegistration";
import ForgotPassword from "./pages/ForgotPassword";
import SegmentRegistration from "./pages/SegmentRegistration";
import OrderReceived from './pages/OrderReceived'
import OrderApproved from "./pages/OrderApproved";
import OrderRTD from "./pages/OrderRTD";
import OrderOnTheWay from "./pages/OrderOnTheWay";
import InWarehouse from "./pages/InWarehouse";
import OrderDispatched from "./pages/OrderDispatched";
import OrderDelivered from "./pages/OrderDelivered";
import PaymentsPending from "./pages/PaymentsPending";
import PaymentsReceived from "./pages/PaymentsReceived";
import PaymentsToBePaid from "./pages/PaymentsToBePaid";
import PaymentsPaid from "./pages/PaymentsPaid";
import PaymentDispatchHistory from "./pages/PaymentDispatchHistory";
import LiveRates from "./pages/LiveRates";
function ProtectedRoute({ children }) {
  const { Operator } = useOperator();
  const location = useLocation();
  const isAuthenticated = !!Operator?.OperatorId;

  if (!isAuthenticated) {
    return <Navigate to="/operatorlogin" state={{ from: location }} replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <OperatorProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/operatorlogin" replace />} />
            <Route path="/operatorlogin" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/jreapproval"
              element={
                <ProtectedRoute>
                  <JreApproval />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jrelive"
              element={
                <ProtectedRoute>
                  <AdminLiveMap />
                </ProtectedRoute>
              }
            />
            <Route
              path="/homepage"
              element={
                <ProtectedRoute>
                  <Homepage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/liverates"
              element={
                <ProtectedRoute>
                  <LiveRates />
                </ProtectedRoute>
              }
            />
            <Route path="/ordersreceived" element={<OrderReceived />} />
            <Route path="/ordersApproved" element={<OrderApproved />} />
            <Route path="/ordersRTD" element={<OrderRTD />} />
            <Route path="/ordersOnTheWay" element={<OrderOnTheWay />} />
            <Route path="/inWarehouse" element={<InWarehouse />} />
            <Route path="/ordersDispatched" element={<OrderDispatched />} />
            <Route path="/ordersDelivered" element={<OrderDelivered />} />
            <Route path="/paymentsPending" element={<PaymentsPending />} />
            <Route path="/paymentsReceived" element={<PaymentsReceived />} />
            <Route path="/paymentsToBePaid" element={<PaymentsToBePaid />} />
            <Route path="/paymentsPaid" element={<PaymentsPaid />} />
            <Route path="/paymentDispatchHistory" element={<PaymentDispatchHistory />} />
            <Route path="/operatorRegistration" element={<OperaotrRegistration />} />
            <Route path="/segmentRegistration" element={<SegmentRegistration />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="*" element={<Navigate to="/operatorlogin" replace />} />
          </Routes>
        </Router>
      </OperatorProvider>
    </AuthProvider>
  );
}

export default App;
